<div class="settlements-list-view-wrapper">
    <div>
        <p class="settlements-list-title" data-cy="settlements-list-title-graphic">PERIODS</p>
        <app-period-type-info-chart [periodTypeInfoChartData]="periodTypeInfoChartData"></app-period-type-info-chart>
    </div>
    <div>
        <p class="settlements-list-title" data-cy="settlements-list-title">{{settlementsListTitle}}</p>
        <app-bundle-settlements-table [settlementsData]="settlementsList" [currency]="getCurrency"></app-bundle-settlements-table>
    </div>
</div>
